module.exports = __webpack_public_path__ + "static/media/skills-mapping-img-005.2253debc.jpg";